var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stk-py-6"},[_c('TaskIndex',{attrs:{"title":"Active Tasks","status":"accepted"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }